<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="163" height="133" viewBox="0 0 163 133" fill="none">
    <path
      d="M108.548 39.8103V131H2V2H70.8125L108.548 39.8103Z"
      fill="white"
      stroke="currentColor"
      stroke-width="2.78446"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M108.777 39.8103H71.0415V2"
      stroke="currentColor"
      stroke-width="2.78446"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.6797 54.1875H76.3934"
      stroke="currentColor"
      stroke-width="2.78446"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.6797 27.2983H43.097"
      stroke="currentColor"
      stroke-width="2.78446"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.6797 41.1074H43.097"
      stroke="currentColor"
      stroke-width="2.78446"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.6797 66.6147H77.7958"
      stroke="currentColor"
      stroke-width="2.78446"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.6797 79.1562H77.7958"
      stroke="currentColor"
      stroke-width="2.78446"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M70.7283 106.388C69.6237 106.388 68.7283 107.283 68.7283 108.388C68.7283 109.492 69.6237 110.388 70.7283 110.388V108.388V106.388ZM161.584 109.802C162.365 109.021 162.365 107.755 161.584 106.973L148.856 94.2456C148.075 93.4645 146.808 93.4645 146.027 94.2456C145.246 95.0266 145.246 96.2929 146.027 97.074L157.341 108.388L146.027 119.701C145.246 120.482 145.246 121.749 146.027 122.53C146.808 123.311 148.075 123.311 148.856 122.53L161.584 109.802ZM70.7283 108.388V110.388L160.169 110.388V108.388V106.388L70.7283 106.388V108.388Z"
      fill="currentColor"
    />
  </svg>
</template>
